import React, { useState, useEffect } from 'react';
import { CheckCircle2, XCircle, Users } from 'lucide-react';

// PS PLASTY CATERING SECTION - Dynamic guest count (base: 80 guests)
const PSPlastyCatering = ({ guestCount = 80, setGuestCount, onTotalChange }) => {
  const BASE_GUEST_COUNT = 80; // Původní kalkulace pro 80 hostů
  const ratio = guestCount / BASE_GUEST_COUNT; // Poměr pro přepočet
  
  // State pro interaktivní položky (Live Cooking) - PAUŠÁLNÍ CENY
  const [liveCookingItems, setLiveCookingItems] = useState({
    paella: { selected: false, price: 20000, name: 'Live Paella — od rodilého Španěla Miguela' },
    colorSushi: { selected: false, price: 25000, name: 'COLOR SUSHI - Lukáš Neckář show' }
  });

  const toggleLiveCooking = (key) => {
    setLiveCookingItems(prev => ({
      ...prev,
      [key]: { ...prev[key], selected: !prev[key].selected }
    }));
  };

  // Vypočítat celkovou cenu live cooking (PAUŠÁL - nemění se s počtem hostů)
  const liveCookingTotal = Object.values(liveCookingItems)
    .filter(item => item.selected)
    .reduce((sum, item) => sum + item.price, 0);
  
  // Helper funkce pro přepočet počtu a ceny
  const calcCount = (baseCount) => Math.ceil(baseCount * ratio);
  const calcTotal = (baseCount, pricePerUnit) => Math.ceil(baseCount * ratio) * pricePerUnit;

  const cateringData = {
    lunch: {
      title: "Catering",
      subtitle: "Formou švédských stolů",
      heroImage: "https://images.unsplash.com/photo-1693463399197-e6063452cf07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwYnVmZmV0JTIwZm9vZCUyMGRpc3BsYXklMjBjYXRlcmluZ3xlbnwwfHx8fDE3NzQ1MjI2Mjl8MA&ixlib=rb-4.1.0&q=85",
      sections: [
        {
          name: "Maso grilované v celku, krájené před hosty",
          items: [
            { name: "Plněné sele", portion: "1000g (kg)", baseCount: 4, pricePerUnit: 799 },
            { name: "Vepřová kýta", portion: "1000g (kg)", baseCount: 4, pricePerUnit: 599 }
          ]
        },
        {
          name: "Teplý raut",
          items: [
            { name: "Grilovaný losos s bylinkovou omáčkou", portion: "100g", baseCount: 16, pricePerUnit: 165 },
            { name: "Medailonky z vepřové panenky, pepřová omáčka", portion: "100g", baseCount: 16, pricePerUnit: 130 },
            { name: "Vepřová žebírka v BBQ marinádě", portion: "200g", baseCount: 16, pricePerUnit: 109 },
            { name: "Kuřecí paličky ve sweet chilli omáčce", portion: "200g", baseCount: 16, pricePerUnit: 89 },
            { name: "Kuřecí roláda plněná vepřovým masem a špenátem s omáčkou demi glace", portion: "50g", baseCount: 16, pricePerUnit: 60 }
          ]
        },
        {
          name: "Přílohy",
          items: [
            { name: "Pečené zelené lusky se slaninkou", portion: "100g", baseCount: 40, pricePerUnit: 45 },
            { name: "Pečené brambory grenaille na bylinkách a másle", portion: "100g", baseCount: 80, pricePerUnit: 45 },
            { name: "Grilovaná sezonní zelenina", portion: "100g", baseCount: 40, pricePerUnit: 50 },
            { name: "Grilovaná kukuřice", portion: "100g", baseCount: 20, pricePerUnit: 55 },
            { name: "Zelný salát coleslaw", portion: "100g", baseCount: 40, pricePerUnit: 30 },
            { name: "Míchaný zeleninový salát, balkánský sýr, medovo hořčičný dresing", portion: "100g", baseCount: 40, pricePerUnit: 50 }
          ]
        },
        {
          name: "Omáčky a dresingy",
          items: [
            { name: "Francouzský, bylinkový, česnekový dresing", portion: "50g", baseCount: 40, pricePerUnit: 25 }
          ]
        },
        {
          name: "Studený raut",
          items: [
            { name: "Kuřecí banketní řízečky obalované v sezamu", portion: "50g", baseCount: 40, pricePerUnit: 55 },
            { name: "Vepřové banketní řízečky z panenky marinované v česneku", portion: "50g", baseCount: 20, pricePerUnit: 65 },
            { name: "Tatarák, topinky", portion: "50g", baseCount: 20, pricePerUnit: 126 },
            { name: "Anglický roastbeef", portion: "50g", baseCount: 20, pricePerUnit: 119 }
          ]
        },
        {
          name: "Doplňky",
          items: [
            { name: "Koš čerstvého banketního pečiva", portion: "15 ks", baseCount: 80, pricePerUnit: 15 }
          ]
        }
      ]
    },
    liveCookingShow: {
      title: "LIVE COOKING SHOW",
      subtitle: "Interaktivní gastronomický zážitek - PAUŠÁLNÍ CENY",
      heroImage: "https://images.unsplash.com/photo-1671612451404-f4f8fc5fe25e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYnVmZmV0JTIwZm9vZCUyMGRpc3BsYXklMjBjYXRlcmluZ3xlbnwwfHx8fDE3NzQ1MjI2Mjl8MA&ixlib=rb-4.1.0&q=85",
      sections: [
        {
          name: "Live Cooking stanice",
          items: [
            { name: "Paella Španělsko - Miguel", portion: "paušál", count: 1, pricePerUnit: 20000, total: 20000, isInteractive: true, key: 'paella', isFixed: true },
            { 
              name: "COLOR SUSHI - Lukáš Neckář show", 
              portion: "paušál", 
              count: 1, 
              pricePerUnit: 25000, 
              total: 25000, 
              isInteractive: true, 
              key: 'colorSushi',
              isFixed: true,
              description: `
🍣 Až 3hodinová live sushi show s interakcí s hosty
📦 200 bambusových lodiček × 3 ks sushi = 600 kusů celkem
🎨 COLOR SUSHI koncept:
   • Růžová rýže (červená řepa) + takuan
   • Žlutá kari rýže + marinovaná variace
   • Klasická bílá rýže + okurka
✅ Kompletní servis (sojová omáčka, wasabi, zázvor, hůlky)
👨‍🍳 Kuchař s TV zkušenostmi + průběžné rolování
🎬 Video: youtube.com/watch?v=ObCpGk7tgzk

Cena zahrnuje: suroviny, přípravu, live show, catering i dopravu
              `.trim()
            }
          ]
        }
      ]
    },
    coffeeBreak: {
      title: "COFFEE BREAK",
      subtitle: "Formou švédských stolů",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/tdtdtgvc__AMK1373.jpg",
      sections: [
        {
          name: "Kanapky",
          items: [
            { name: "S parmskou šunkou", portion: "50g", baseCount: 20, pricePerUnit: 49 },
            { name: "Se sýrem Brie", portion: "50g", baseCount: 20, pricePerUnit: 49 },
            { name: "S uzeným lososem", portion: "50g", baseCount: 20, pricePerUnit: 55 },
            { name: "Mini wrapy", portion: "50g", baseCount: 20, pricePerUnit: 55 },
            { name: "Mini burger", portion: "50g", baseCount: 20, pricePerUnit: 80 }
          ]
        },
        {
          name: "Dezert",
          items: [
            { name: "Carrot cake - mrkvový dort s ořechy", portion: "180g", baseCount: 24, pricePerUnit: 89 },
            { name: "Čokoládový dort s malinami", portion: "100g", baseCount: 28, pricePerUnit: 89 },
            { name: "Karamelový dort s datlemi", portion: "100g", baseCount: 28, pricePerUnit: 89 }
          ]
        }
      ]
    },
    dinner: {
      title: "VEČEŘE",
      subtitle: "Podávání z foodtrucků",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/f2myg582_FoodTruck.jpg",
      sections: [
        {
          name: "Hlavní chody",
          items: [
            { name: "Hovězí žebra na přírodní topince z kváskového chleba, bbq, coleslaw", portion: "150g", baseCount: 20, pricePerUnit: 285 },
            { name: "Smash beef burger (Irský chuckroll, slanina, cheddar, polníček, okurka, rajče, domácí bun)", portion: "150g", baseCount: 20, pricePerUnit: 210 },
            { name: "Quesadillas - zapečená tortilla s čedarem, mozzarellou, pomalu pečeným trhaným masem", portion: "100g", baseCount: 20, pricePerUnit: 210 },
            { name: "Tacos Combo - Kombinace tří různých tacos. Malá kukuřičná tortila, trhaná BBQ vepřová", portion: "120g", baseCount: 20, pricePerUnit: 210 }
          ]
        },
        {
          name: "Dezert",
          items: [
            { name: "Vdolečky", portion: "10 ks", baseCount: 80, pricePerUnit: 15 },
            { name: "Makové a ořechové koláčky", portion: "20 ks", baseCount: 40, pricePerUnit: 15 },
            { name: "Frgále", portion: "50 ks", baseCount: 40, pricePerUnit: 35 },
            { name: "Zmrzlina kopečková", portion: "50 ks", baseCount: 40, pricePerUnit: 35 }
          ]
        }
      ]
    },
    drinks: {
      title: "NÁPOJOVÝ SERVIS — ALL INCLUSIVE",
      subtitle: "Kompletní nápojové zázemí pro celou akci",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/1qpehocp__AMK1902.jpg",
      sections: [
        {
          name: "Degustace rumů (15:00 - 22:00)",
          items: [
            { name: "Degustace rumů — dle přesné spotřeby", portion: "min. ks", baseMinCount: 40, pricePerUnit: 120, isMinimum: true }
          ]
        },
        {
          name: "Koktejly mix vč. nealkoholických (15:00 - 24:00)",
          items: [
            { name: "Koktejly mix (Mojito, Piña Colada, Sex on the Beach, Gin Tonic, Aperol Spritz, Whiskey Sour, Cosmopolitan, Mai Tai, Cuba Libre) + nealkoholické — dle přesné spotřeby", portion: "min. ks", baseMinCount: 80, pricePerUnit: 120, isMinimum: true }
          ]
        },
        {
          name: "Pivo čepované",
          items: [
            { name: "Plzeňský Prazdroj — dle přesné spotřeby", portion: "min. ks", baseMinCount: 100, pricePerUnit: 60, isMinimum: true },
            { name: "Birell (nealkoholické) — dle přesné spotřeby", portion: "min. ks", baseMinCount: 40, pricePerUnit: 50, isMinimum: true },
            { name: "Birell Pomelo Grep — dle přesné spotřeby", portion: "min. ks", baseMinCount: 40, pricePerUnit: 50, isMinimum: true }
          ]
        },
        {
          name: "Nealkoholické nápoje",
          items: [
            { name: "Pepsi, Mirinda, 7up — dle přesné spotřeby", portion: "min. ks", baseMinCount: 40, pricePerUnit: 50, isMinimum: true },
            { name: "Red Bull — dle přesné spotřeby", portion: "min. ks", baseMinCount: 40, pricePerUnit: 70, isMinimum: true },
            { name: "Voda (perlivá / neperlivá) — dle přesné spotřeby", portion: "min. ks", baseMinCount: 60, pricePerUnit: 40, isMinimum: true }
          ]
        }
      ]
    },
    staff: {
      title: "PERSONÁL & REŽIE",
      subtitle: "Obsluha, vybavení a logistika",
      heroImage: "https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/mvetv4fd_290807044_434303445370941_8352434526447174514_n-3%281%29.jpg",
      sections: [
        {
          name: "Personál",
          items: [
            { name: "Kuchaři", portion: "hod", baseCount: 24, pricePerUnit: 220 },
            { name: "Servírky / číšníci", portion: "hod", baseCount: 32, pricePerUnit: 190 },
            { name: "Barmani", portion: "hod", baseCount: 16, pricePerUnit: 210 }
          ]
        },
        {
          name: "Režie a vybavení",
          items: [
            { name: "Food truck", portion: "paušál", baseCount: 1, pricePerUnit: 5000 },
            { name: "Nádobí, příbory, sklo", portion: "paušál", baseCount: 1, pricePerUnit: 6000 },
            { name: "Stoly, tepelné vany", portion: "paušál", baseCount: 1, pricePerUnit: 2480 },
            { name: "Doprava a logistika", portion: "paušál", baseCount: 1, pricePerUnit: 4800 },
            { name: "Koordinátor akce", portion: "hod", baseCount: 12, pricePerUnit: 290 }
          ]
        }
      ]
    }
  };

  // Vypočítat celkový Grand Total a poslat ho do PSPlastyPage
  useEffect(() => {
    const grandTotal = Object.entries(cateringData).reduce((total, [key, data]) => {
      if (key === 'liveCookingShow') {
        return total + liveCookingTotal;
      }
      
      const sectionTotal = data.sections.reduce((sum, section) => {
        return sum + section.items.reduce((itemSum, item) => {
          if (item.isFixed) {
            return itemSum + (item.isInteractive && liveCookingItems[item.key]?.selected ? item.total : 0);
          }
          if (item.baseCount !== undefined) {
            return itemSum + calcTotal(item.baseCount, item.pricePerUnit);
          }
          if (item.baseMinCount !== undefined) {
            return itemSum + calcTotal(item.baseMinCount, item.pricePerUnit);
          }
          return itemSum + (item.total || 0);
        }, 0);
      }, 0);
      
      return total + sectionTotal;
    }, 0);
    
    // Zavolat callback s celkovou cenou
    if (onTotalChange) {
      onTotalChange(grandTotal);
    }
  }, [guestCount, liveCookingItems, onTotalChange]);

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-slate-950 to-[#020617]">
      <div className="max-w-7xl mx-auto">
        {/* Main Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 text-center">
          CATERING & GASTRO
        </h2>
        <p className="text-slate-400 text-lg mb-8 text-center max-w-3xl mx-auto">
          Kompletní gastronomický servis. Celodenní catering ve stylu evropských festivalů s live cooking stanicemi a food trucky.
        </p>

        {/* Guest Count Slider */}
        <div className="bg-gradient-to-r from-[#FF6B00]/20 to-[#FF6B00]/10 border-2 border-[#FF6B00]/50 rounded-xl p-8 mb-12">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <Users className="w-8 h-8 text-[#FF6B00]" />
              <h3 className="text-2xl font-bold text-white">Počet hostů</h3>
            </div>
            <div className="text-5xl font-bold text-[#FF6B00]">{guestCount}</div>
          </div>
          <input
            type="range"
            min="50"
            max="120"
            value={guestCount}
            onChange={(e) => setGuestCount(Number(e.target.value))}
            className="w-full h-3 bg-slate-700 rounded-lg appearance-none cursor-pointer"
            style={{
              background: `linear-gradient(to right, #FF6B00 0%, #FF6B00 ${((guestCount - 50) / 70) * 100}%, #334155 ${((guestCount - 50) / 70) * 100}%, #334155 100%)`
            }}
          />
          <div className="flex justify-between text-slate-400 text-sm mt-2">
            <span>50 hostů</span>
            <span>120 hostů</span>
          </div>
          <p className="text-slate-300 text-sm mt-4 text-center">
            💡 Přesuňte posuvník pro automatický přepočet všech položek cateringu
          </p>
        </div>

        {/* Visual Gallery - pouze 2 položky */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {/* Live Paella - Klikací */}
          <div 
            onClick={() => toggleLiveCooking('paella')}
            className={`relative group overflow-hidden rounded-xl border-2 transition-all cursor-pointer ${
              liveCookingItems.paella.selected 
                ? 'border-[#FF6B00] shadow-lg shadow-[#FF6B00]/30' 
                : 'border-white/10 hover:border-[#FF6B00]/50'
            }`}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/0oqd0z21_44319726_1091573427668908_8957835176973434880_n.jpg"
              alt="Live Paella" 
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex flex-col justify-end p-6">
              <div className="flex items-center gap-3 mb-2">
                {liveCookingItems.paella.selected ? (
                  <div className="w-8 h-8 bg-[#FF6B00] rounded-full flex items-center justify-center">
                    <CheckCircle2 className="w-6 h-6 text-white" />
                  </div>
                ) : (
                  <div className="w-8 h-8 border-2 border-white/50 rounded-full flex items-center justify-center">
                    <div className="w-4 h-4 bg-white/30 rounded-full"></div>
                  </div>
                )}
                <span className="text-[#FF6B00] font-bold text-2xl">20 000 Kč</span>
              </div>
              <p className="text-white font-bold text-xl">Live Paella — od rodilého Španěla Miguela</p>
              <p className="text-slate-300 text-sm mt-1">Klikněte pro přidání do rozpočtu</p>
            </div>
          </div>

          {/* COLOR SUSHI - Klikací */}
          <div 
            onClick={() => toggleLiveCooking('colorSushi')}
            className={`relative group overflow-hidden rounded-xl border-2 transition-all cursor-pointer ${
              liveCookingItems.colorSushi.selected 
                ? 'border-[#FF6B00] shadow-lg shadow-[#FF6B00]/30' 
                : 'border-white/10 hover:border-[#FF6B00]/50'
            }`}
          >
            <img 
              src="https://images.pexels.com/photos/36317042/pexels-photo-36317042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="COLOR SUSHI" 
              className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex flex-col justify-end p-6">
              <div className="flex items-center gap-3 mb-2">
                {liveCookingItems.colorSushi.selected ? (
                  <div className="w-8 h-8 bg-[#FF6B00] rounded-full flex items-center justify-center">
                    <CheckCircle2 className="w-6 h-6 text-white" />
                  </div>
                ) : (
                  <div className="w-8 h-8 border-2 border-white/50 rounded-full flex items-center justify-center">
                    <div className="w-4 h-4 bg-white/30 rounded-full"></div>
                  </div>
                )}
                <span className="text-[#FF6B00] font-bold text-2xl">25 000 Kč</span>
              </div>
              <p className="text-white font-bold text-xl">COLOR SUSHI - Lukáš Neckář show</p>
              <p className="text-slate-300 text-sm mt-1">Klikněte pro přidání do rozpočtu</p>
            </div>
          </div>
        </div>

        {/* Catering Sections */}
        {Object.entries(cateringData).map(([key, data]) => (
          <div key={key} className="mb-12">
            {/* Hero Image + Title */}
            <div className="relative h-64 rounded-t-xl overflow-hidden">
              <img 
                src={data.heroImage}
                alt={data.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent flex items-end">
                <div className="p-8 w-full">
                  <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">
                    🍽️ {data.title}
                  </h3>
                  <p className="text-slate-300 text-lg">{data.subtitle}</p>
                </div>
              </div>
            </div>

            {/* Tables */}
            <div className="bg-slate-900/40 border border-white/10 rounded-b-xl p-6">
              {data.sections.map((section, idx) => (
                <div key={idx} className="mb-8 last:mb-0">
                  <h4 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                    <span className="w-2 h-2 bg-[#FF6B00] rounded-full"></span>
                    {section.name}
                  </h4>
                  
                  {/* Table */}
                  <div className="overflow-x-auto">
                    <table className="w-full text-left">
                      <thead>
                        <tr className="border-b border-white/10">
                          <th className="pb-3 text-slate-400 font-semibold">Položka</th>
                          <th className="pb-3 text-slate-400 font-semibold text-center">Gramáž/ks</th>
                          <th className="pb-3 text-slate-400 font-semibold text-center">
                            {key === 'staff' ? 'ks/hodin' : 'Počet porcí'}
                          </th>
                          <th className="pb-3 text-slate-400 font-semibold text-right">Cena/ks</th>
                          <th className="pb-3 text-slate-400 font-semibold text-right">Celkem</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.items.map((item, itemIdx) => {
                          // Dynamický výpočet pro normální položky
                          const dynamicCount = item.isFixed || item.count === 1 || item.count === '∞' 
                            ? item.count 
                            : item.isMinimum 
                              ? calcCount(item.baseMinCount)
                              : item.baseCount 
                                ? calcCount(item.baseCount)
                                : item.count;
                          
                          const dynamicTotal = item.isFixed 
                            ? item.total 
                            : item.isMinimum 
                              ? calcTotal(item.baseMinCount, item.pricePerUnit)
                              : item.baseCount 
                                ? calcTotal(item.baseCount, item.pricePerUnit)
                                : item.total;

                          return (
                          <>
                            <tr key={itemIdx} className="border-b border-white/5 last:border-0">
                              <td className="py-3 text-white">
                                {item.name}
                                {item.isInteractive && liveCookingItems[item.key]?.selected && (
                                  <span className="ml-2 text-xs bg-[#FF6B00] text-white px-2 py-1 rounded">PŘIDÁNO</span>
                                )}
                                {item.isInteractive && !liveCookingItems[item.key]?.selected && (
                                  <span className="ml-2 text-xs bg-slate-700 text-slate-400 px-2 py-1 rounded">NEPŘIDÁNO</span>
                                )}
                              </td>
                              <td className="py-3 text-center">
                                <span className="text-green-400 font-semibold">{item.portion}</span>
                              </td>
                              <td className="py-3 text-white text-center">
                                {item.isMinimum && 'min. '}
                                {dynamicCount}
                              </td>
                              <td className="py-3 text-slate-300 text-right">{item.pricePerUnit.toLocaleString('cs-CZ')} Kč</td>
                              <td className="py-3 text-right">
                                {item.isInteractive ? (
                                  <span className={`font-bold ${liveCookingItems[item.key]?.selected ? 'text-[#FF6B00]' : 'text-slate-600'}`}>
                                    {dynamicTotal.toLocaleString('cs-CZ')} Kč
                                  </span>
                                ) : (
                                  <span className="text-[#FF6B00] font-bold">{dynamicTotal.toLocaleString('cs-CZ')} Kč</span>
                                )}
                              </td>
                            </tr>
                            {item.description && (
                              <tr key={`${itemIdx}-desc`} className="border-b border-white/5">
                                <td colSpan="5" className="py-4 px-4 bg-slate-900/30">
                                  <div className="text-slate-300 text-sm whitespace-pre-line leading-relaxed">
                                    {item.description}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        )})}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}

              {/* Section Total - Dynamický výpočet */}
              <div className="mt-6 pt-6 border-t border-white/20 flex justify-between items-center">
                <span className="text-white font-bold text-xl">Celkem {data.title.split('(')[0].trim()}:</span>
                <span className="text-[#FF6B00] font-bold text-2xl">
                  {(() => {
                    // Pro Live Cooking - pouze sečíst vybrané položky (PAUŠÁL)
                    if (key === 'liveCookingShow') {
                      return liveCookingTotal.toLocaleString('cs-CZ');
                    }
                    
                    // Pro ostatní sekce - dynamický přepočet
                    const sectionTotal = data.sections.reduce((sum, section) => {
                      return sum + section.items.reduce((itemSum, item) => {
                        if (item.isFixed) {
                          return itemSum + (item.isInteractive && liveCookingItems[item.key]?.selected ? item.total : 0);
                        }
                        if (item.baseCount !== undefined) {
                          return itemSum + calcTotal(item.baseCount, item.pricePerUnit);
                        }
                        if (item.baseMinCount !== undefined) {
                          return itemSum + calcTotal(item.baseMinCount, item.pricePerUnit);
                        }
                        return itemSum + (item.total || 0);
                      }, 0);
                    }, 0);
                    return sectionTotal.toLocaleString('cs-CZ');
                  })()}
                  {' '}Kč
                </span>
              </div>
            </div>
          </div>
        ))}

        {/* Grand Total - Dynamický výpočet */}
        <div className="mt-12 bg-gradient-to-r from-[#FF6B00]/20 to-[#FF6B00]/10 border-2 border-[#FF6B00]/50 rounded-xl p-8">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">CELKOVÝ CATERING</h3>
              <p className="text-slate-300">Včetně všech služeb, personálu a režie pro {guestCount} hostů</p>
              <p className="text-slate-400 text-sm mt-2">*Vyúčtování na základě reálné spotřeby nápojů</p>
            </div>
            <div className="text-right">
              <div className="text-5xl font-bold text-[#FF6B00]">
                {(() => {
                  // Výpočet celkového cateringu
                  const grandTotal = Object.entries(cateringData).reduce((total, [key, data]) => {
                    if (key === 'liveCookingShow') {
                      return total + liveCookingTotal;
                    }
                    
                    const sectionTotal = data.sections.reduce((sum, section) => {
                      return sum + section.items.reduce((itemSum, item) => {
                        if (item.isFixed) {
                          return itemSum + (item.isInteractive && liveCookingItems[item.key]?.selected ? item.total : 0);
                        }
                        if (item.baseCount !== undefined) {
                          return itemSum + calcTotal(item.baseCount, item.pricePerUnit);
                        }
                        if (item.baseMinCount !== undefined) {
                          return itemSum + calcTotal(item.baseMinCount, item.pricePerUnit);
                        }
                        return itemSum + (item.total || 0);
                      }, 0);
                    }, 0);
                    
                    return total + sectionTotal;
                  }, 0);
                  
                  return grandTotal.toLocaleString('cs-CZ');
                })()} Kč
              </div>
              <p className="text-slate-400 text-sm mt-2">Orientační kalkulace pro {guestCount} hostů</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PSPlastyCatering;
